<template>
  <div>
    <NotFound v-if="show404" return-path-name="find-symptoms" />
    <div v-else>
      <div class="container" v-if="isLoading">
        <div class="row">
          <div class="d-flex justify-content-center">
            <Loading />
          </div>
        </div>
      </div>
      <div class="repair" v-else>
        <div class="container">
          <div class="row">
            <h5>Naprawa</h5>
            <h1 class="intro-text">
              <strong>{{ repair.name }}</strong>
            </h1>
          </div>
        </div>

        <div class="col-12 line container">Wyceny dla twojego samochodu</div>

        <div class="container" v-if="isCalculatedLoading">
          <div class="row">
            <div class="d-flex justify-content-center">
              <Loading />
            </div>
          </div>
        </div>
        <div class="container" v-else-if="getSelectedCar">
          <ul v-if="calculatedRepair.calculatedPrices.length">
            <li
              v-for="variant in calculatedRepair.calculatedPrices"
              :key="variant.repair.name"
            >
              <varianted-cost :variant="variant" />
            </li>
          </ul>
          <ul v-else>
            <li>brak danych</li>
          </ul>
        </div>
        <div v-else class="selected-car deforce-mobile">
          <div class="select-car-for-seeing-costs container">
            <a @click="scrollToSelectingCar">
              <p class="big">Wybierz samochód,</p>
              <p class="light">Sprawdź koszty naprawy</p>
            </a>
          </div>
        </div>

        <description
          :repair="repair"
          :calculatedRepair="calculatedRepair"
          :isCalculatedLoading="isCalculatedLoading"
          class="mt-4"
        />
        <foot-notes />
        <div class="container">
          <div class="row">
            <div class="col-12">
              <mail-to-us
                bold-text="Zapytaj eksperta"
                small-text="o twój problem z samochodem"
                :object-id="repair.id"
                :type="FormTypes.REPAIR"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import NotFound from "@/views/NotFound";
import Loading from "@/components/Loading";
import Description from "@/components/repair-detail-components/Description";
import MailToUs from "@/improvementForms/MailToUs";
import FootNotes from "@/components/repair-detail-components/FootNotes";
import VariantedCost from "@/components/repair-detail-components/VariantedCost";
import { mapGetters, mapMutations } from "vuex";
import { FormTypes } from "@/improvementForms/formTypes";

export default {
  mounted() {
    if (this.getInitObject.object) {
      this.repair = this.getInitObject.object;
      document.title = this.repair.name;
      this.resetInitObject();
    } else {
      this.fetchRepair();
    }
  },
  data: function () {
    return {
      repair: {},
      calculatedRepair: {},
      show404: false,
      isLoading: false,
      isCalculatedLoading: false,
      FormTypes,
    };
  },
  methods: {
    ...mapMutations(["resetInitObject"]),
    fetchRepair() {
      this.isLoading = true;
      axios
        .get(`/api/faults/repair/${this.$route.params.repairId}/`)
        .then((response) => {
          this.repair = response.data;
          document.title = this.repair.name;
          this.isLoading = false;
        })
        .catch((reason) => {
          if (reason.response.status === 404) {
            this.show404 = true;
          } else {
            console.error(reason);
          }
        });
    },
    fetchCalculatedRepair() {
      this.isCalculatedLoading = true;
      axios
        .get(`/api/faults/calculated_repair/${this.$route.params.repairId}/`)
        .then((response) => {
          this.calculatedRepair = response.data;
          this.isCalculatedLoading = false;
        });
    },
    scrollToSelectingCar() {
      document
        .getElementById("selecting-car")
        .scrollIntoView({ behavior: "smooth" });
    },
  },
  watch: {
    "$route.params.repairId": {
      handler: function () {
        this.fetchRepair();
        this.fetchCalculatedRepair();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar"]),
    ...mapGetters(["getInitObject"]),
  },
  components: {
    FootNotes,
    MailToUs,
    Description,
    NotFound,
    Loading,
    VariantedCost,
  },
};
</script>
<style scoped>
h5 {
  font-family: Comfortaa-light, serif;
  color: gray;
}

h1,
h6 {
  font-family: Roboto, sans-serif;
}

.selected-car {
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  background-color: rgba(99, 70, 218, 0.3);
}

.selected-car .elements {
  max-width: 840px;
  margin-left: auto;
  margin-right: auto;
  font-family: "Comfortaa", "serif";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: -0.015em;
}

.line {
  font-weight: bold;
  font-size: 17px;
  width: 100%;
  border-bottom: 2px solid black;
}

.select-car-for-seeing-costs a {
  text-decoration: none;
  color: black;
}

.select-car-for-seeing-costs .big {
  font-family: "Comfortaa", serif;
  font-weight: bold;
  font-size: 28px;
  margin: 0;
  line-height: 36px;
  letter-spacing: -0.015em;
}

.select-car-for-seeing-costs .light {
  font-family: "Comfortaa-light", serif;
  font-weight: 700;
  font-size: 22px;
  margin: 0;
}
</style>
